import {call, put, takeEvery} from 'redux-saga/effects';
import {FETCH_DEALER_PLANNING_CONFIGURATION, SAVE_DEALER_PLANNING_CONFIGURATION} from '../constants/ActionTypes';
import DealerConfigurationService from '../services/api/DealerConfigurationService';
import {fetchDealerPlanningConfigurationFailure, fetchDealerPlanningConfigurationSuccess, saveDealerPlanningConfigurationFailure, saveDealerPlanningConfigurationSuccess} from '../actions/planningConfigurationActions';

function* fetchDealerPlanningConfiguration() {
  try {
    const dealerPlanningConfiguration = yield call(DealerConfigurationService.getDealerPlanningConfiguration);
    yield put(fetchDealerPlanningConfigurationSuccess(dealerPlanningConfiguration.body));
  } catch (error) {
    yield put(fetchDealerPlanningConfigurationFailure(error));
  }
}

function* saveDealerPlanningConfiguration(action) {
  try {
    const dealerPlanningConfiguration = yield call(() => DealerConfigurationService.saveDealerPlanningConfiguration(action.payload));
    yield put(saveDealerPlanningConfigurationSuccess(dealerPlanningConfiguration.body));
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
  } catch (error) {
    yield put(saveDealerPlanningConfigurationFailure(error));
  }
}

export function* watchDealerPlanningConfiguration() {
  yield takeEvery(FETCH_DEALER_PLANNING_CONFIGURATION, fetchDealerPlanningConfiguration);
  yield takeEvery(SAVE_DEALER_PLANNING_CONFIGURATION, saveDealerPlanningConfiguration);
}
